// The request the Quote Generator sends for "Get Canopy's take". Pure: no React, no network.
//
// Privacy (EULA section 8.2): known client, vendor, job and business names are replaced before sending
// (see src/aiPrivacy.js). The quote's own name and notes are not sent at all, because the assessment
// does not need them and a quote is often named after the client. Cost line descriptions are sent
// (the AI comments on lines that look unusual); known names inside them are replaced. The job type and benchmark label are category labels and are sent as typed.

export const QUOTE_CHECK_SYSTEM = "You are a concise financial analyst for a small business owner. Be clear and balanced; suggest things to consider, not commands.";

// text: { jobType, revenue, totalCosts, grossProfit, grossMargin, costBreakdown, benchmarkInfo } (already formatted)
export function buildQuoteCheckBody(text, privacy) {
  const prompt = `You are a sharp financial advisor for a small business. The user is pricing out a potential job. Analyze this estimate and give a short, balanced assessment in 3-4 sentences, using specific numbers. Mention things they may want to consider, but do not tell them what they must do.

ESTIMATE:
Job Type: ${text.jobType || "Not specified"}
Expected Revenue: ${text.revenue}
Total Estimated Costs: ${text.totalCosts}
Gross Profit: ${text.grossProfit}
Gross Margin: ${text.grossMargin}%

COST BREAKDOWN:
${privacy.pseudonymize(text.costBreakdown) || "No cost lines entered."}

${text.benchmarkInfo}

Give a short, balanced assessment: Is the margin healthy? How does it compare to their history? Any specific cost lines that look unusual? Mention things they may want to consider (for example reviewing pricing or costs), without telling them what to do. Keep it under 100 words.`;
  return {
    system: privacy.pseudonymize(QUOTE_CHECK_SYSTEM),
    max_tokens: 500,
    messages: [{ role: "user", content: prompt }],
    names_removed: true,
  };
}
